import React, { useEffect, useRef } from "react";
import s from './UserRecognition.module.scss'
import { AudioModule } from "./AudioModule/AudioModule";
import { useSelector } from "react-redux";
import { ResultModuleNew } from "./ResultModule/ResultModuleNew";
import { useTranslation } from "react-i18next";

export const UserRecognition = () => {
    const { status } = useSelector(state => state.recognize)
    const containerRef = useRef(null);

    const { t } = useTranslation()

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ block: 'start' });
        }
    }, [status]);
    return (
        <div className={s.wrapper}>
            <div>
                <div className={s.container} ref={containerRef}>
                    
                    <div className={s.tittle}>
                        {t('recognitionTitle')}
                    </div>
                    {status !== 'succeeded' ?  <AudioModule  /> 
                    : <ResultModuleNew />}     
                </div>
                <div className={s.upperCloud}></div>
                <div className={s.uuderCloud}></div>
            </div>
        </div>
    )
}